/*
 * Created Date: 10-10-2021, 10:11:55 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2021 VNE E-COMMERCE, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { FormControlLabel, FormLabel, Switch } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { Controller } from 'react-hook-form'

const CoreSwitch = props => {
	const { className, control, name, legendLabel, label, ...restProps } = props

	return (
		<div className={className}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, value } }) => {
					return (
						<>
							{legendLabel && <FormLabel component="legend">{legendLabel}</FormLabel>}
							<FormControlLabel
								control={
									<Switch
										checked={value === 'true' ? true : value === 'false' ? false : value}
										onChange={onChange}
										{...restProps}
									/>
								}
								label={label}
							/>
						</>
					)
				}}
			/>
		</div>
	)
}

CoreSwitch.defaultProps = {
	className: null,
	legendLabel: null,
	label: ''
}

CoreSwitch.propTypes = {
	className: PropTypes.string,
	control: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	legendLabel: PropTypes.string,
	label: PropTypes.string
}

export default React.memo(CoreSwitch)
